import APIFetcher from '../APIFetcher';

class DistrictLeaderApi {
  static persistDistrictLeader(payload) {
    const url = `district-leader/${payload.id + '/' || ''}`;
    return APIFetcher.post(url, {payload});
  }
}

export default DistrictLeaderApi;
